export default "__VITE_ASSET__Nwuf1ClC__"